// Конфігурація опцій наявності
export const PRESENCE_OPTIONS = [
  { value: "available", label: "В наявності" },
  { value: "not_available", label: "Немає в наявності" },
  { value: "order", label: "Під замовлення" },
];

// Хелпер-функція для отримання текстової мітки статусу наявності за його значенням
export const getPresenceLabel = (value) => {
  const option = PRESENCE_OPTIONS.find((opt) => opt.value === value);
  return option ? option.label : value || "---";
};

// Майданчики, з яких збираються ловушки
export const PLATFORM_OPTIONS = [
  { value: "prom", label: "Prom" },
  { value: "horoshop", label: "Horoshop" },
];

// Хелпер-функція для отримання назви платформи за її кодом
export const getPlatformLabel = (value) => {
  const option = PLATFORM_OPTIONS.find((opt) => opt.value === value);
  return option ? option.label : value || "---";
};

// Значення фільтра магазину — "платформа:id"
export const buildShopFilterValue = (platform, shopId) => `${platform}:${shopId}`;

export const parseShopFilterValue = (value) => {
  if (!value) return { platform: null, shopId: null };
  const [platform, shopId] = String(value).split(":");
  return { platform: platform || null, shopId: shopId || null };
};
